import React, {PureComponent} from "react";

class FormField extends PureComponent {
    getClassName = () => {
        const {meta: {touched, error}, className} = this.props;

        return [
            className,
            touched && error ? 'is-invalid' : undefined
        ].filter(el => el != null).join(' ');
    };
}

export default FormField;